import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MdePopoverComponent } from './mde-popover.component';
import { MdePopoverTriggerDirective } from './mde-popover-trigger.directive';

@NgModule({
  imports: [OverlayModule, PortalModule],
  declarations: [MdePopoverComponent, MdePopoverTriggerDirective],
  exports: [MdePopoverComponent, MdePopoverTriggerDirective],
})
export class MdePopoverModule {}
